
export class Utils {

    public static MakeEmailBreakable(email: string): string {
        return email.replace('@', "<wbr>@");
    }


}
